import { categories } from '@/mocks/videos';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <nav className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide flex-wrap" aria-label="影视分类">
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onCategoryChange(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          <i className={`${cat.icon} text-xs`}></i>
          {cat.name}
          <span className={`text-xs ml-0.5 ${
            activeCategory === cat.slug ? 'text-white/80' : 'text-foreground-400'
          }`}>
            {cat.count}
          </span>
        </button>
      ))}
    </nav>
  );
}